import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/theme.css';
import './css/theme-additions.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById('root');

const appTree = (
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap pre-renders HTML at build time. When the DOM already contains
// rendered content we hydrate; otherwise we do a fresh client render.
// This is what lets LLM crawlers and Googlebot see your content without
// executing JavaScript.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
